import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import PageLoader from "../../shared/PageLoader";
import { Alert } from "react-bootstrap";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { useForgotPassword } from "../../../backend/auth";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import { AxiosError } from "axios";
import backArrow from "./../../../assets/img/auth-back-arrow.svg";

function ForgotPasswordCard({ onClose }: any) {
    const [recoverySent, setRecoverySent] = useState(false);
    const [apiError, setError] = useState<any>(null);
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState<any>({});
    const [message, setMessage] = useState<string>("");
    const { forgotPassword } = useForgotPassword((response: any) => {
        setSubmitting(false);
        if (response instanceof AxiosError) {
            const { data } = (response || {}).response || {};
            const error = (data || {}).error || (data || {}).message || ERROR_MESSAGES.ERROR;
            setError(error);
        } else {
            setMessage(response.data.message)
            setRecoverySent(true);
        }
    }, () => {
        setSubmitting(false);
        setError(ERROR_MESSAGES.DEFAULT);
    });

    const schema = {
        fields: [{
            ...LOGIN_FIELDS.USERNAME,
            label: 'Username',
            placeholder: 'Enter Username',
            className: 'ciel-auth-field',
        }],
    };

    function recoverPassword({ username }: any) {
        setError(null);
        if (form.valid) {
            setSubmitting(true);
            forgotPassword({ username });
        }
    }

    return (
        <div className="ciel-auth-card">
            <button type="button" className="ciel-auth-back-link" onClick={onClose}>
                <img src={backArrow} alt="" />
                Back to Login page
            </button>
            {
                recoverySent ?
                    <div className="d-flex flex-column align-items-center text-center ciel-auth-recovery-success">
                        <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: '64px' }} className="mb-3 text-success" />
                        <div className="ciel-auth-heading"><h2>Email Sent</h2><p>{message}</p></div>
                    </div> :
                    <>
                        <div className="ciel-auth-heading">
                            <h2>Recover Password</h2>
                            <p>Enter your username and we'll send you a link to reset your password</p>
                        </div>
                        {
                            apiError && <Alert variant="danger">{apiError}</Alert>
                        }
                        <FormRenderer FormTemplate={FormTemplate}
                            initialValues={{ submitBtnText: 'Send Link to Email', fullWidth: true }}
                            componentMapper={ComponentMapper}
                            schema={schema}
                            debug={setForm}
                            onSubmit={recoverPassword}
                        />
                    </>
            }
            {submitting && <PageLoader />}
        </div>
    )
}

export default ForgotPasswordCard;
